import React from 'react';
import TitleBanner from './TitleBanner';
import { useState } from 'react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
    return (
      <div className="border-b border-purple-200">
        <button
          className="w-full py-4 px-2 flex justify-between items-center text-left"
          onClick={onClick}
        >
          <span className="text-gray-900">{question}</span>
          <svg
            className={`w-6 h-6 text-primary transform transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
        {isOpen && (
          <div className="p-4 bg-purple-50 rounded-lg">
            <p className="text-gray-700">{answer}</p>
          </div>
        )}
      </div>
    );
  };
  
  const Resources = () => {
    const [openQuestions, setOpenQuestions] = useState({});
  
    const faqData = [
      {
        question: "What is SDA?",
        answer: "Specialist Disability Accommodation (SDA) refers to accommodation for people who require specialist housing solutions, including assisting with delivery of supports that cater for their extreme functional impairment or very high support needs."
      },
      {
        question: "How do I know if I am eligible for SDA Funding?",
        answer: "To access SDA funding, you will need to have SDA included in your NDIS plan. If you need it and its not there, you can seek help from you Support Coordinator, Local Area Coordinator or NDIS planner."
      },
      {
        question: "What is Short Term/Respite Accommodation?",
        answer: "Short Term Accommodation, including respite, is funding for support and accommodation for a short time away from your usual home. It covers the cost of your care in another place for up to 14 days at a time."
      },
      {
        question: "What is Medium Term Accommodation (MTA)",
        answer: "Medium Term Accommodation can support you if you need somewhere to live while waiting for your confirmed long term housing solution. This funding covers up to 90 days."
      },
      {
        question: "What will it cost me?",
        answer: "The rent you will pay is equivalent to 25% of the Disability Support Pension."
      },
      {
        question: "How many people will I be living with?",
        answer: "As part of our onboarding process, we ensure we match participants in line with their likes, dislikes, hobbies, and behavioural profile, therefore you always have choice and control. Number of bedrooms and people living within depends on the type of property. We offer 3,4 and 5-bedroom ensuite homes."
      },
      {
        question: "Will I have privacy?",
        answer: "Livability Care respects the privacy of all participants. "
      },
      {
        question: "Does Livability Care provide both housing and care?",
        answer: "At Livability Care, we provide tailored support services to NDIS participants. We have partnered with trusted NDIS registered housing providers to build “High Physical Support”, “Robust” and “Non-SDA” homes for our participants. This combination of services makes us unique."
      },
      {
        question: "Can I bring my own support workers?",
        answer: "Livability Care provides SIL in all our “High Physical Support” and “Robust” homes. We have highly qualified support workers who constantly upskill themselves to provide you with the best care."
      },
      {
        question: "How can I arrange an inspection of a Livability Care Property?",
        answer: "We are always happy to show you, our properties. Give our friendly team a call 1300 522 786 to arrange a suitable day and time for viewing. You can also email us info@livabilitycare.com.au or fill out one of our Expression of Interest form in the meantime and we will get back to you as soon as we can."
      }
    ];
  
    const toggleQuestion = (index) => {
      setOpenQuestions(prev => ({
        ...prev,
        [index]: !prev[index]
      }));
    };




    
  return (
    <>
    <TitleBanner image="/Website_Title_Images/Resources.svg" title="Resources" subheading="Find what you need about NDIS & SDA here" />
    <div className="max-w-6xl mx-auto p-6 bg-white">
      {/* SDA Eligibility Section */}
      <section className="mb-8">
        <h1 className="text-primary font-arial-rounded text-3xl font-bold mb-4">SDA Eligibility</h1>
        
        <p className="mb-4 text-xl">
          Specialist disability accommodation (SDA) is designed to work with various
          funded supports. Eligibility for SDA is determined by considering the required
          supports and how they will integrate. SDA is only funded if it is a better option for
          the disability support needs compared to other supports alone.
        </p>

        <div className="mb-4">
          <p className="mb-2">Eligibility criteria for SDA include:</p>
          <ul className="list-disc pl-6">
            <li className="mb-1">Extreme functional impairment or very high support needs</li>
            <li className="mb-1">Requirement for specialist disability accommodation</li>
            <li className="mb-1">Meeting NDIS funding criteria for SDA</li>
          </ul>
        </div>

        <p className="mb-4">
          Additional evidence, such as reports from allied health professionals, may be
          requested to assess eligibility. All evidence provided is used to determine
          eligibility for SDA.
        </p>

        <p className="mb-4">
          Participants already living in SDA when they join NDIS remain eligible.
        </p>
      </section>

      {/* NDIS Section */}
      <section>
        <h2 className="text-primary font-arial-rounded text-3xl font-bold mb-4">NDIS</h2>
        
        <p className="mb-4 text-xl">
          The NDIS takes a lifetime approach, investing in people with disability at an early
          stage to improve their outcomes later in life. The NDIS can provide all people with
          disability with information and connections to services in their communities such
          as doctors, sporting clubs, support groups, libraries and schools, as well as
          information about what support is provided by each state and territory
          government.
        </p>

        <ul className="list-none">
          <li className="mb-1">
            <a href="https://livabilitycare.com.au/" className="text-primary hover:underline">• Visit NDIS website</a>
          </li>
          <li>
            <a href="#" className="text-primary hover:underline">• Download Price Guide</a>
          </li>
        </ul>
      </section>
      
    </div>
    <div className="mx-auto bg-white">
    <section className="bg-purple-100 p-6 rounded-lg">
        <h2 className="text-primary font-arial-rounded text-2xl font-bold mb-6">FREQUENTLY ASKED QUESTIONS</h2>
        <div className="space-y-2 px-2 md:px-12">
          {faqData.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openQuestions[index]}
              onClick={() => toggleQuestion(index)}
            />
          ))}
        </div>
      </section>
      </div>
    </>
  );
};

export default Resources;